import React, { HTMLAttributes, useEffect } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import Layout from "components/Layout";
import Bgimg from "@/assets/images/academy/nft-1.png";

// import { Hooks } from "@xt/xtbase";
// const { useTranslation } = Hooks;
// import store from "store";

import styles from "./index.module.less";

interface Props extends HTMLAttributes<HTMLDivElement> {
  attr?: any;
}

const Main: React.FC<Props> = ({ className }) => {
  // const t = useTranslation();
  // const {isLogin} = store.user;
  useEffect(() => {
    const htmlEl = document.documentElement;
    htmlEl.style.fontSize = "39px";
  }, []);

  return (
    <Layout>
      <div className={cx(styles.nft, className)}>
        <img src={Bgimg} />
        <ul>
          <li>
            <div>
              <h2>What to expect from NTF's in the future</h2>
              <h4>
                With a flourishing Metaverse, the future of NFT's is bright. We've witnessed NFT's transition from being something merely experimental, to
                something practical and on its way to becoming mainstream.
              </h4>
              <h4>
                <p className={cx(styles.dot, className)}></p>
                While the history of NFTs is intriguing, the future of NFTs has endless opportunities as the new space transitions from raw and experimental to
                exceedingly more useful and mainstream. Through tokenization, programmability, collaboration, royalties, and more direct connections between
                artists and collectors, NFTs may soon be a technology vital to everyday life. Concepts like DAOs, token-based Metaverses, community owned
                financial protocols, and NFT art were small scale experiments just a few years ago. Now they represent multi-billion dollar communities that
                combine protocol-driven design, economics, and governance as global collectives on the internet. It may be challenging to predict the future,
                but for digital art collecting, it's safe to say we have yet to imagine the extent of what will emerge in decades to come.
              </h4>
            </div>
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default observer(Main);
// export default Main;
